import { makeStyles } from "@material-ui/core/styles";


export default makeStyles((theme) => ({
  close: {
    color: theme.palette.grey[700],
    height: 18,
    "&:hover": {
      cursor: "pointer",
    },
  },
  head: {
    alignItems: "center",
    display: "flex",
    fontSize: 16,
    justifyContent: "space-between",
    paddingBottom: 16,
    textTransform: "uppercase",
  },
  list: {
    maxHeight: 205,
    overflowY: "auto",
  },
  menu: {
    color: theme.palette.grey[900],
    cursor: "default",
    fontFamily: "Source Sans Pro,Arial,sans-serif",
    fontSize: 12,
  },
  popover: {
    borderRadius: 12,
    padding: 16,
  },
  viewersButton: {
    backgroundColor: "transparent",
    border: `1px solid ${theme.palette.primary.main}`,
    boxShadow: "none",
    fontWeight: "bold",
    textTransform: "none",
  },
  viewersButtonEmphasized: {
    backgroundColor: theme.palette.error.main,
    boxShadow: "none",
    fontWeight: "bold",
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));
